import { ReactNode } from 'react'
import { Button } from '@mui/material'

import { useStyles } from './styles'

interface IProps {
  text: string | ReactNode
  startIcon?: ReactNode
  color?: 'primary' | 'dark' | 'light'
  disabled?: boolean
  inline?: boolean
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  sx?: object
  size?: 'small' | 'medium' | 'large'
}

export const ScannerButton = ({
  inline,
  text,
  color = 'primary',
  size = 'large',
  ...props
}: IProps) => {
  const classes = useStyles({ color })

  return (
    <Button
      fullWidth={!inline}
      size={size}
      className={classes.button}
      variant="contained"
      {...props}
    >
      {text}
    </Button>
  )
}
